import React from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import {getProductsAndServices, goToPage, initStandAlonePurchaseSale, resetBlock, reportDWH} from './StandAlonePurchaseSaleSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {ePages} from './Constants';
// --- PAGES --- //
import SubscriptionsInfoPage from './Pages/SubscriptionsInfoPage';
import ProductPurchasePage from './Pages/ProductPurchasePage';
import TechnicianSlotsPage from './Pages/TechnicianSlotsPage';
import CheckoutPage from './Pages/CheckoutPage';
import DeliveryPage from './Pages/DeliveryPage';
import ErrorPage from './Pages/ErrorPage';
import SuccessPage from './Pages/SuccessPage';

// --- COMPONENTS -- //
import ProgressBar from '../../Shared/ProgressBar/progressBar';
import {Container} from 'reactstrap';

const StandAlonePurchaseSale = (props) => {
  let currentView = '';

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      (async () => {
        props.showAppLoader();
        await props.initStandAlonePurchaseSale({iContent: props.iContent});
        const response = await props.getProductsAndServices();
        if (response.payload.returnCode != '00') {
          props.reportDWH({
            actionType: 'Entered Choosing Eq Page',
            statusText: 'Error',
            messageText: 'General Error',
          });
        }
        props.hideAppLoader();
      })();
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

  useClearStateResetFlag();

  switch (props.page) {
    case ePages.SUBSCRIPTIONS_INFO_PAGE: // step 1
      currentView = <SubscriptionsInfoPage context={props.context} />;
      break;
    case ePages.PRODUCT_PURCHASE_PAGE: // step 2
      currentView = <ProductPurchasePage context={props.context} />;
      break;
    case ePages.PRODUCT_EXTENDED_INFO_PAGE: // optional
      currentView = 'הרחבה של הנתונים';
      break;
    case ePages.DELIVERY_PAGE: // step 3
      currentView = <DeliveryPage context={props.context} />;
      break;
    case ePages.TECHNICIAN_SLOTS_PAGE: // step 4
      currentView = <TechnicianSlotsPage context={props.context} />;
      break;
    case ePages.CHECKOUT_PAGE: // step 5
      currentView = <CheckoutPage context={props.context} />;
      break;
    case ePages.SUCCESS_PAGE: // step 6
      currentView = <SuccessPage context={props.context} />;
      break;
    case ePages.ERROR_PAGE: // error
      currentView = <ErrorPage />;
      break;
  }

  return (
    props.initCompleted && (
      <>
        <ProgressBar points={props.progressBarPoints} percent={props.percent} />
        <Container className='stand-alone-purchase-page'>{currentView}</Container>
      </>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    initCompleted: state.standAlonePurchaseSaleBlock?.initCompleted,
    selectedDeliverySlot: state.standAlonePurchaseSaleBlock?.selectedDeliverySlot,
    progressBarPoints: state.standAlonePurchaseSaleBlock?.progressBarPoints,
    percent: state.standAlonePurchaseSaleBlock?.percent,
    page: state.standAlonePurchaseSaleBlock?.page,
    tvProducts: state.standAlonePurchaseSaleBlock?.tvProducts,
    returnCode: state.standAlonePurchaseSaleBlock?.returnCode, //TODO: refer to error page
  };
};

const mapDispatchToProps = {
  initStandAlonePurchaseSale,
  getProductsAndServices,
  goToPage,
  resetBlock,
  showAppLoader,
  hideAppLoader,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(StandAlonePurchaseSale);
